/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react';
import UIApplication from 'UIComponents/app/UIApplication';
import { AppProvider as TrellisAppProvider } from 'trellis-components/components/AppProvider';
import { RhumbProvider as RhumbProviderBase } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
// @ts-ignore untyped loader
import { name as packageName } from 'current-package-loader!';
import { I18nHMRProvider } from 'I18n/components/I18nHMRProvider';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { RouterProvider } from 'quartz-routing';
import { renderRoot } from './root';
import { ErrorPage } from '../components/ErrorPage';
import { GlobalErrorBoundary } from '../components/GlobalErrorBoundary';
// @ts-ignore untyped
import config from 'quartz-config-loader!';

// Extend the published RhumbProvider props type to include graniteHealthThresholds,
// which is added in the react-rhumb PR that this quartz PR depends on.
import { jsx as _jsx } from "react/jsx-runtime";
const RhumbProvider = RhumbProviderBase;
const quartzConfig = getQuartzConfig();
const Routes = /* quartzConfig.type === 'application' && (quartzConfig.experimentalFsRouting || quartzConfig.UNSAFE_EXPERIMENTAL_routing && quartzConfig.UNSAFE_EXPERIMENTAL_routing.experimentalFsRouting) */false ? require('quartz-routing/FsRoutes').FsRoutes : React.Fragment;
export function AppRoot({
  children,
  history,
  rhumbConfig,
  rhumbTrackVisibility,
  userId,
  softNavigationContext,
  staticAppInfo,
  skipRhumbProvider,
  isGraniteEnabled,
  isGraniteRemoteApp,
  graniteHealthThresholds
}) {
  const routerContent = /*#__PURE__*/_jsx(RouterProvider, {
    history: history,
    children: /*#__PURE__*/_jsx(Routes, {
      children: children
    })
  });
  return /*#__PURE__*/_jsx(UIApplication, {
    name: packageName,
    children: /*#__PURE__*/_jsx(TrellisAppProvider, {
      children: /*#__PURE__*/_jsx(I18nHMRProvider, {
        children: skipRhumbProvider ? /*#__PURE__*/_jsx(GlobalErrorBoundary, {
          ErrorComponent: ErrorPage,
          children: routerContent
        }) : /*#__PURE__*/_jsx(RhumbProvider, {
          history: historyAdapter(history),
          config: rhumbConfig,
          trackVisibility: rhumbTrackVisibility,
          ErrorComponent: ErrorPage,
          userId: userId != null ? String(userId) : undefined,
          softNavigationContext: softNavigationContext,
          staticAppInfo: staticAppInfo,
          isGraniteEnabled: isGraniteEnabled,
          isGraniteRemoteApp: isGraniteRemoteApp,
          graniteHealthThresholds: graniteHealthThresholds,
          children: routerContent
        })
      })
    })
  });
}
function RenderWithCallback({
  callback,
  children
}) {
  // While this effect can be called more than once in newer versions of react
  // the promise will only resolve once.
  React.useLayoutEffect(() => {
    callback();
  }, [callback]);
  return children;
}

// Promise.withResolvers "ponyfill"
function promiseWithResolvers() {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return {
    promise,
    resolve,
    reject
  };
}
export function renderAppRoot(reactElement, options) {
  let maybeRoot;
  const {
    promise,
    resolve
  } = promiseWithResolvers();

  // We have to define this before it gets assigned so it can be passed into the resolve
  // eslint-disable-next-line prefer-const
  maybeRoot = renderRoot( /*#__PURE__*/_jsx(RenderWithCallback, {
    callback: () => resolve(maybeRoot),
    children: reactElement
  }), {
    copilotLayoutType: options.copilotLayoutType,
    legacyRoot: options.legacyRoot,
    strictMode: options.strictMode,
    isCopilotDisabled: options.isCopilotDisabled,
    container: options.container,
    hasTrellisModernizedLayout: config.UNSAFE_EXPERIMENTAL_hasTrellisModernizedLayout,
    isGraniteEnabled: options.isGraniteEnabled,
    isGraniteRemoteApp: options.isGraniteRemoteApp
  });
  return promise;
}